export enum MenuDisplayMode {
  EXPANDED = 'expanded',
  SHRINKED = 'shrinked',
  PROFILE = 'profile',
}
